/* eslint-disable
    func-names,
    max-len,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const ClientOverviewLedgersCtrl = function (
  _,
  $state,
  LedgerCollection,
  LedgerWithTransactionsCollection,
  AddOnCollection,
  CategorizerRuleCollection,
  LedgerCategoryCollection,
  ClientSettings,
) {
  this.ledgers = new LedgerCollection(this.clientId);
  this.ledgersWithTransactions = new LedgerWithTransactionsCollection(this.clientId);
  this.addOns = new AddOnCollection(this.clientId);
  this.rules = new CategorizerRuleCollection(this.clientId);
  this.ledgerCategories = new LedgerCategoryCollection();
  this.settings = new ClientSettings(this.clientId);
  this.unusedLedgersHidden = false;

  let collapsedRules = {};
  this.groupedRules = {};
  this.rules.$onSet(() => {
    this.groupedRules = this.rules.$groupByCategory();
    return (collapsedRules = _.mapValues(this.groupedRules, rule => true));
  });

  // use an array rather than an object because we want order to be preserved
  this.views = [
    {
      label: 'Add Ons',
      tabHeader: 'Add Ons & Accounts',
      selected: true,
      widthClass: 'addons',
      normal: [],
      addOn: [],
    },
    {
      label: 'Revenues',
      selected: false,
      widthClass: 'category',
      normal: [],
      addOn: [],
    },
    {
      label: 'Cost of Sales',
      selected: false,
      widthClass: 'category',
      normal: [],
      addOn: [],
    },
    {
      label: 'Operating Expenses',
      selected: false,
      widthClass: 'category',
      normal: [],
      addOn: [],
    },
    {
      label: 'Assets',
      selected: false,
      widthClass: 'category',
      normal: [],
      addOn: [],
    },
    {
      label: 'Liabilities',
      selected: false,
      widthClass: 'category',
      normal: [],
      addOn: [],
    },
    {
      label: 'Equity',
      selected: false,
      widthClass: 'category',
      normal: [],
      addOn: [],
    },
  ];

  /*
  sorts all ledgers into a format similar to this:
  {
    normal:
      assets:
        ...
      liabilities:
        ...
      equity:
        ...
      revenues:
        ...
      expenses:
        ...
    addOn:
      same as normal
  }
  */
  const sortLedgers = ledgers => {
    const groupLedgers = isAddOn =>
      _.chain(ledgers.data)
        .filter(ledger => ledger.isAddOn === isAddOn)
        .groupBy('categoryId')
        .mapKeys((value, key) =>
          _.join(_.words(this.ledgerCategories.$findById(key).name), '').toLowerCase(),
        )
        .value();

    return {
      normal: groupLedgers(false),
      addOn: groupLedgers(true),
    };
  };

  this.addOns.$onSet(() => (this.views[0].addOn = this.addOns.data));

  this.ledgers.$onSet(() => {
    const sortedLedgers = sortLedgers(this.ledgers);

    // because order needs to be preserved, assignment looks gross here
    this.views[1].normal = sortedLedgers.normal.revenues || [];
    this.views[1].addOn = sortedLedgers.addOn.revenues || [];
    this.views[2].normal = sortedLedgers.normal.costofsales || [];
    this.views[2].addOn = sortedLedgers.addOn.costofsales || [];
    this.views[3].normal = sortedLedgers.normal.operatingexpenses || [];
    this.views[3].addOn = sortedLedgers.addOn.operatingexpenses || [];
    this.views[4].normal = sortedLedgers.normal.assets || [];
    this.views[4].addOn = sortedLedgers.addOn.assets || [];
    this.views[5].normal = sortedLedgers.normal.liabilities || [];
    this.views[5].addOn = sortedLedgers.addOn.liabilities || [];
    this.views[6].normal = sortedLedgers.normal.equity || [];
    return (this.views[6].addOn = sortedLedgers.addOn.equity || []);
  });

  this.actionText = function () {
    if (this.unusedLedgersHidden) {
      return 'Show';
    }
    return 'Hide';
  };

  this.toggleLedgersHidden = function () {
    return (this.unusedLedgersHidden = !this.unusedLedgersHidden);
  };

  this.shouldDisplay = (ledger, view) => {
    const isUsedLedger = ledger =>
      ledger.isAddOn ||
      ledger.role != null ||
      this.ledgersWithTransactions.$findById(ledger.id) != null;

    const isAAViewSelected = this.views[0].selected;

    const ledgerIsNormalAndNormalViewSelected = view.normal.includes(ledger) && view.selected;
    const ledgerIsAddOnAndAAViewSelected = view.addOn.includes(ledger) && isAAViewSelected;
    const ledgerIsAccountAndAAViewSelected = ledger.role != null && isAAViewSelected;

    // check whether flag is active and if it's a ledger or add-on only model
    const checkUsedLedger = this.unusedLedgersHidden && ledger.constructor.name === 'Ledger';

    return (
      (ledgerIsNormalAndNormalViewSelected ||
        ledgerIsAddOnAndAAViewSelected ||
        ledgerIsAccountAndAAViewSelected) &&
      (checkUsedLedger ? isUsedLedger(ledger) : true)
    );
  };

  this.getDisplayed = view => {
    // sort ledgers by alphabetical order for now
    const sort = ledgers => _.sortBy(ledgers, ledger => ledger.name);

    const accounts = _.filter(view.normal, ledger => ledger.role != null);
    const normals = _.difference(view.normal, accounts);
    const [sortedAccounts, sortedNormals] = Array.from(_.map([accounts, normals], sort));
    const sortedAddOns = sort(view.addOn);

    // display accounts, then add-ons, then everything else
    const allLedgers = sortedAccounts.concat(sortedAddOns.concat(sortedNormals));
    return _.filter(allLedgers, ledger => this.shouldDisplay(ledger, view));
  };

  this.toggleView = function (viewIndex) {
    const view = this.views[viewIndex];
    return (view.selected = !view.selected);
  };

  this.isInfoInView = view => view.addOn.concat(view.normal).length > 0;

  this.getRuleStringForLedger = function (ledgerName) {
    const ledgerRules = this.groupedRules[ledgerName];

    const ledgerStrings = _.map(ledgerRules, ledgerRule => {
      const { minAmount, maxAmount, vendorContains } = ledgerRule;
      return `\
${vendorContains}\
${[minAmount || maxAmount ? ' (' : undefined]}\
${[minAmount ? '>'.concat(minAmount.toString()) : undefined]}\
${[minAmount && maxAmount ? ', ' : undefined]}\
${[maxAmount ? '<'.concat(maxAmount.toString()) : undefined]}\
${[minAmount || maxAmount ? ')' : undefined]}\
`;
    });

    return ledgerStrings.join(', ');
  };

  this.isRuleCollapsed = ledgerName => collapsedRules[ledgerName];

  this.toggleRuleCollapsed = ledgerName =>
    (collapsedRules[ledgerName] = !collapsedRules[ledgerName]);

  this.openLedger = ledger =>
    $state.go('bench.details.overview.form.ledger', { ledgerId: ledger.id });
  this.openAddOn = addOn => $state.go('bench.details.overview.form.addon', { addOnId: addOn.id });
};

module.exports = ClientOverviewLedgersCtrl;
